import { render, staticRenderFns } from "./relJinhengDialog2.vue?vue&type=template&id=70ed24b6"
import script from "./relJinhengDialog2.vue?vue&type=script&lang=js"
export * from "./relJinhengDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports